"use client";
import { useState, useEffect, useRef } from "react";

type Props = {
  duracionMinutos?: number;
  onTimeout?: () => void;
}

export function Temporizador({
  duracionMinutos = 10,
  onTimeout
}: Props) {
  const [tiempoRestante, setTiempoRestante] = useState(duracionMinutos * 60); // segundos
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const onTimeoutRef = useRef(onTimeout);

  useEffect(() => {
    onTimeoutRef.current = onTimeout;
  }, [onTimeout]);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTiempoRestante((prevTiempo) => {
        if (prevTiempo <= 1) {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
          // Ejecutar el callback guardado en el ref
          onTimeoutRef.current?.();
          return 0;
        }
        // Decrementar el tiempo
        return prevTiempo - 1;
      });
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  const minutos = Math.floor(tiempoRestante / 60);
  const segundos = tiempoRestante % 60;
  const formatoTiempo = `${minutos.toString().padStart(2, "0")}:${segundos.toString().padStart(2, "0")}`;

  // Cambiar color cuando queden menos de 2 minutos
  const esUrgente = tiempoRestante < 120;
  const colorTexto = esUrgente ? "text-red-400" : "text-white";
  const colorBorde = esUrgente ? "border-red-400" : "border-white/40";

  return (
    <div className={`mb-4 p-4 rounded-md border-2 ${colorBorde} bg-white/10`}>
      <div className="text-center">
        <p className="text-sm text-white/80 mb-1">Tiempo restante para completar la compra</p>
        <p className={`text-2xl font-bold ${colorTexto} font-mono`}>
          {formatoTiempo}
        </p>
      </div>
    </div>
  );
}

